var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconContactus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.007,
    height: 49,
    viewBox: "0 0 48.007 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email",
    transform: "translate(-0.111 0.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6826",
    "data-name": "Group 6826",
    transform: "translate(0 56.464)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1218",
    "data-name": "Ellipse 1218",
    cx: 24,
    cy: 24.5,
    rx: 24,
    ry: 24.5,
    transform: "translate(0.111 -56.628)",
    fill: "#5f98d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15097",
    "data-name": "Path 15097",
    d: "M168.166,85.186c0-.967-6.336-7.008-9.34-9.648l-9.975.543-5.971,2.98L130.1,76.08l-1.2,18.609,8.933,14.272a24.167,24.167,0,0,0,30.329-23.776Z",
    transform: "translate(-120.048 -117.472)",
    fill: "#3a6da1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6799",
    "data-name": "Group 6799",
    transform: "translate(8.781 14.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15071",
    "data-name": "Path 15071",
    d: "M88.217,156.484v18.621l9.081-9.348Z",
    transform: "translate(-88.217 -155.639)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15072",
    "data-name": "Path 15072",
    d: "M336.343,156.484v18.621l-9.036-9.311Z",
    transform: "translate(-304.914 -155.639)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15073",
    "data-name": "Path 15073",
    d: "M95.558,147.466h29.994l-11.788,12.275a4.449,4.449,0,0,1-6.418,0Z",
    transform: "translate(-94.87 -147.466)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15074",
    "data-name": "Path 15074",
    d: "M114.444,265.349a5.392,5.392,0,0,1-7.778,0l-2-2.082-9.109,9.484h29.994l-9.109-9.484Z",
    transform: "translate(-94.87 -252.421)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContactus);
export default __webpack_public_path__ + "static/media/icon-contactus.3c1ffa09.svg";
export { ForwardRef as ReactComponent };